export const getDomIndex = (
	haystack: HTMLElement[],
	needle: HTMLElement
): number | null => {
	const index = haystack.indexOf(needle);

	return index === -1 ? null : index;
};

const focusableElementSelectors: string = [
	'a:not([disabled]):not([tabindex="-1"])',
	'button:not([disabled]):not([tabindex="-1"])',
	'input[type=text]:not([disabled]):not([tabindex="-1"])',
	'[tabindex]:not([disabled]):not([tabindex="-1"])',
].join(',');

const selectFocusableElements = (
	scopeContainer: HTMLElement = document?.body
) => {
	const focusableElements: HTMLElement[] = [];

	scopeContainer
		.querySelectorAll(focusableElementSelectors)
		.forEach((e) => focusableElements.push(e as HTMLElement));

	return focusableElements;
};

export const getNextFocusableElement = (
	startElement?: HTMLElement,
	scopeContainer?: HTMLElement
): HTMLElement | undefined => {
	const focusableElements: HTMLElement[] =
		selectFocusableElements(scopeContainer);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const currentIndex: number = startElement
		? getDomIndex(focusableElements, startElement)
		: 0;

	return startElement
		? focusableElements[currentIndex + 1] || focusableElements[currentIndex]
		: focusableElements[currentIndex];
};

export const getPrevFocusableElement = (
	startElement?: HTMLElement,
	scopeContainer?: HTMLElement
): HTMLElement | undefined => {
	const focusableElements: HTMLElement[] =
		selectFocusableElements(scopeContainer);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const currentIndex: number = startElement
		? getDomIndex(focusableElements, startElement)
		: 0;

	return focusableElements[currentIndex - 1] || focusableElements[currentIndex];
};

export const getLastFocusableElement = (scopeContainer?: HTMLElement) => {
	const focusableElements: HTMLElement[] =
		selectFocusableElements(scopeContainer);
	return focusableElements[focusableElements.length - 1];
};

export const getFirstFocusableElement = (scopeContainer?: HTMLElement) => {
	const focusableElements: HTMLElement[] =
		selectFocusableElements(scopeContainer);
	return focusableElements[0];
};

export const setCSSVariable = (paramName: string, value: string): void => {
	const root = document.querySelector(':root') as HTMLElement;
	root.style.setProperty(`--${paramName}`, value);
};
